import { createStore } from 'vuex'
import playerStore from './playerStore' 

const store = createStore({
  state: {
    //baseUrl:"http://localhost:3000/",
    //livekitUrl: 'http://localhost:7880',
    //baseUrl: 'http://127.0.0.1:3000/',
    //baseUrl: 'http://10.233.120.12:3000/',
    baseUrl: 'https://wedio.sassayer.com/',
    livekitUrl: 'https://livekit.sassayer.com',
    webClientId: '375999718872-bdqfkhpgv1bg71f7lklruu9taignsabt.apps.googleusercontent.com',
    user:{uid:'',stats:{}, blockedUser:[]},
    userProfile:{stats:{}}, // current profile in profile page
    playLists:[],
    status:{},
    users:{},
    conversationVisible:false,
    chatSetting:{visible:false, otherUser:{
        uid: 'user123',
        name: 'Namexyz',
        avatar: null,
        lastSeen: new Date('2024-03-15T12:00:00Z')
    }},
    onlineUserIds:{},
    //messages:{},
    // store/index.js or wherever you define your Vuex store
    playingAudioId: null,     // ← ADD THIS ( likely to delete )
    audioPlayerIsPlaying: false,
    audioPlayerVisibility: false,
    currentPlayer: null,   // null | 'publication' | 'audioPlayer' | audioCard
    currentConference:null,
    messages: {},
    colors: [
    '#c49b5e', // Gold
    '#8338ec', // Purple
    '#00d4ff', // Cyan
    '#ef4444', // Red
    '#22c55e', // Green
    '#f59e0b', // Orange
    '#ec4899', // Pink
    '#6366f1', // Indigo
    '#14b8a6', // Teal
    '#1e293b', // Dark slate
    ],
    modifyPublication:{publication:{},count:0},
    modifiedPublication:{publication:{},count:0},
    publicationFormVisible:false
  },
  mutations: {
    setPlayingAudioId (state, id) {   // ← ADD THIS ( likely to delete later )
      state.playingAudioId = id
    },
    setAudioPlayerIsPlaying(state, val) { state.audioPlayerIsPlaying = val },
    setAudioPlayerVisibility(state, val) { state.audioPlayerVisibility = val },
    setPublicationFormVisibility(state, val) { state.publicationFormVisible = val },
    setCurrentPlayer(state, val) { state.currentPlayer = val },
    setCurrentConference(state, val) { state.currentConference = val },
    setUser(state,playload) {
      state.user = playload
      // add to global users object
      state.users[playload.uid] = playload
      localStorage.setItem('currentUser__', JSON.stringify(playload))
    },
    setPlayLists (state, playload) {
      state.playLists = playload
      localStorage.setItem('playLists__', JSON.stringify(playload))
    },
    addPlayLists (state, playload) { // add an audio to the playList of PlayLists of the given index
      const index = state.playLists.findIndex(pl => pl.id === playload.playListId)
      if(index === -1) return
      state.playLists[index].audios.push(playload.audio)
      localStorage.setItem('playLists__', JSON.stringify(state.playLists))
    },
    updatePlayList (state, playload) {
      const index = state.playLists.findIndex(pl => pl.id === playload.id)
      if(index === -1) return
      state.playLists[index] = playload
      localStorage.setItem('playLists__', JSON.stringify(state.playLists))
    },
    setUserProfile (state,playload) {
      state.userProfile = playload
    },
    addMyStatus (state,playload) {
      if(!state.status[state.user.uid]) state.status[state.user.uid] = []
      state.status[state.user.uid].push(playload)
    },
    setUserStatuses (state,playload) {
      if(!playload.uid) return
      state.status[playload.uid] = playload.statuses
    },
    setAnUser (state,playload) {
      if(!playload.uid) return
      state.users[playload.uid] = playload
    },
    setUsers (state,playload) {
      state.users = playload
    },
    showConversation (state) {
      state.conversationVisible = true
    },
    closeConversation (state) {
      state.conversationVisible = false
    },
    showChat(state,playload) {
      state.chatSetting.visible = true
      state.chatSetting.otherUser = playload
    },
    closeChat(state) {
      state.chatSetting.visible = false
    },
    setMessages(state, payload) {
      state.messages = payload
    },
    addMessagesToConversation(state, { userId, messages }) {
      if (!state.messages[userId])  state.messages[userId] = [];
      
      messages.forEach(newMsg => {
        // Check if message already exists
        const existingIndex = state.messages[userId].findIndex(m => m._id === newMsg._id);
        if (existingIndex === -1) {
          // Add new message
          state.messages[userId].push(newMsg);
        } else {
          // Update existing message
          state.messages[userId][existingIndex] = newMsg;
        }
      });
      
      // Sort by createdAt
      state.messages[userId].sort((a, b) => 
        new Date(a.createdAt) - new Date(b.createdAt)
      );
    },
    updateMessage(state, { userId, messageId, updates }) {
      if (state.messages[userId]) {
        const msgIndex = state.messages[userId].findIndex(m => m._id === messageId);
        if (msgIndex !== -1) {
          state.messages[userId][msgIndex] = {
            ...state.messages[userId][msgIndex],
            ...updates
          };
        }
      }
    },
    deleteMessage(state, { userId, messageId }) { // remove it from array
      if (!state.messages[userId]) state.messages[userId] = []
      const existingIndex = state.messages[userId].findIndex(m => m._id === messageId);
      if(existingIndex !== -1) state.messages[userId].splice(existingIndex,1)
    },
    setOnlineUserIds(state, playload) {
      state.onlineUserIds = playload
    },
    setModifyPublication(state, playload) {
      state.modifyPublication.publication = playload
      state.modifyPublication.count++
    },
    setModifiedPublication(state, playload) {
      state.modifiedPublication.publication = playload
      state.modifiedPublication.count++
    }
  },
  actions: {
  },
  modules: {
    player: playerStore
  },
})


//--------- automatically save a light version of state.messages on each new message
function getLightMessagesState(messages, users, user, limit = 5) {
  const lightMessages = {}, messageUsers = {};
  messageUsers[user.uid] = user
  Object.keys(messages).forEach(userId => {
    const userMessages = messages[userId] || [];
    messageUsers[userId] = users[userId]

    lightMessages[userId] =
      userMessages.length > limit
        ? userMessages.slice(-limit)
        : userMessages;
  });

  return {lightMessages:lightMessages, messageUsers:messageUsers};
}

store.subscribe((mutation, state) => {
  if (mutation.type.includes('Message')) {
    const pl = getLightMessagesState(state.messages, state.users, state.user)

    localStorage.setItem(
      'messages',
      JSON.stringify(pl.lightMessages)
    )
    localStorage.setItem(
      'users',
      JSON.stringify(pl.messageUsers)
    )
  }
})

export default store